import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-280de2b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "Carte Confituur | Werk", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "canonical",
  href: "https://www.carteconfituur.be/projects"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "description",
  content: "Carte Confituur neemt elk project aan en overloopt met u alle stappen. Een overzicht."
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:title",
  content: "Carte Confituur | Werk"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:url",
  content: "https://www.carteconfituur.be/projects"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:description",
  content: "Carte Confituur neemt elk project aan en overloopt met u alle stappen. Een overzicht."
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:type",
  content: "article"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:title",
  content: "Carte Confituur | Werk"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:description",
  content: "Carte Confituur neemt elk project aan en overloopt met u alle stappen. Een overzicht."
}, null, -1))
const _hoisted_10 = { class: "projects" }
const _hoisted_11 = { class: "projectsWrapper" }
const _hoisted_12 = { class: "filtersWrapper" }
const _hoisted_13 = { class: "filters" }
const _hoisted_14 = { class: "mobileFilters" }
const _hoisted_15 = { class: "dropdownfilters" }
const _hoisted_16 = { class: "activeFilter" }
const _hoisted_17 = { class: "dropdownIcon" }
const _hoisted_18 = { class: "projectListWrapper" }
const _hoisted_19 = { class: "projectsList" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectItemComponent = _resolveComponent("ProjectItemComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_1
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_2
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_3
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_4
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_5
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_6
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_7
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_8
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_9
    ])),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", {
              class: _normalizeClass({active: _ctx.activeFilters.ALL}),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filter('ALL')))
            }, "ALLE", 2),
            _createElementVNode("span", {
              class: _normalizeClass({active: _ctx.activeFilters.GEBOORTE}),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter('GEBOORTE')))
            }, "GEBOORTE", 2),
            _createElementVNode("span", {
              class: _normalizeClass({active: _ctx.activeFilters.HUWELIJK}),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter('HUWELIJK')))
            }, "HUWELIJK", 2),
            _createElementVNode("span", {
              class: _normalizeClass({active: _ctx.activeFilters.BRANDING}),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter('BRANDING')))
            }, "BRANDING", 2)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: "visibleFilter",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openCloseFilters()))
              }, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.getActiveFilter()), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("i", {
                    class: _normalizeClass([{hidden: _ctx.filtersOpen}, "arrow down"])
                  }, null, 2),
                  _createElementVNode("i", {
                    class: _normalizeClass([{hidden: !_ctx.filtersOpen}, "arrow up"])
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["dropdownOptions", {visible: _ctx.filtersOpen}])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([{active: _ctx.activeFilters.ALL, hidden: _ctx.activeFilters.ALL}, "dropdownOption"]),
                  onClick: _cache[5] || (_cache[5] = () => {_ctx.filter('ALL'); _ctx.openCloseFilters(); })
                }, "ALLE", 2),
                _createElementVNode("div", {
                  class: _normalizeClass([{active: _ctx.activeFilters.GEBOORTE, hidden: _ctx.activeFilters.GEBOORTE}, "dropdownOption"]),
                  onClick: _cache[6] || (_cache[6] = () => {_ctx.filter('GEBOORTE'); _ctx.openCloseFilters(); })
                }, "GEBOORTE", 2),
                _createElementVNode("div", {
                  class: _normalizeClass([{active: _ctx.activeFilters.HUWELIJK, hidden: _ctx.activeFilters.HUWELIJK}, "dropdownOption"]),
                  onClick: _cache[7] || (_cache[7] = () => {_ctx.filter('HUWELIJK'); _ctx.openCloseFilters(); })
                }, "HUWELIJK", 2),
                _createElementVNode("div", {
                  class: _normalizeClass([{active: _ctx.activeFilters.BRANDING, hidden: _ctx.activeFilters.BRANDING}, "dropdownOption"]),
                  onClick: _cache[8] || (_cache[8] = () => {_ctx.filter('BRANDING'); _ctx.openCloseFilters(); })
                }, "BRANDING", 2)
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProjects, (project) => {
              return (_openBlock(), _createBlock(_component_ProjectItemComponent, {
                class: "actualProjectItem",
                item: project,
                key: project.id
              }, null, 8, ["item"]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}